import { lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";

import LoadingScreen from "../../../shared/components/LoadingScreen";
import AuthGuard from "../../../shared/guards/AuthGuard";
import ShopLayout from "../../../shared/layouts/shopLayout";
// import TransactionsApproval from "../components/TransactionsApproval";


const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();

    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
            <Component {...props} />
        </Suspense>
    );
};
const KTDAProcessing = Loadable(lazy(() => import('../view')));

export const KTDAProcessingRoutes = [
    // Dashboard Routes
    {
        path: 'shop-dashboard',
        element: (
            <AuthGuard>
                <ShopLayout />
            </AuthGuard>
        ),
        children: [
            { path: 'ktda-payments-processings', element: <KTDAProcessing /> }
        ],
    },

];